import React from 'react';
import { cn } from '../../poker-ui/utils/cn';

const OUTER_CLASS = cn(
  'relative mx-auto flex w-max min-w-0 max-w-[min(100%,8.5rem)] sm:max-w-[min(100%,9rem)] flex-col items-center justify-center pb-[5px]',
  'motion-safe:animate-[app-toast-in_230ms_cubic-bezier(0.2,0.8,0.2,1)] motion-reduce:animate-none',
  'motion-safe:transition-[opacity,transform] motion-safe:duration-300 motion-safe:ease-out',
);

const PILL_BASE = cn(
  'flex min-h-0 min-w-0 w-full max-w-full items-center justify-center rounded-full px-1.5 py-[2px] sm:px-2 sm:py-[3px]',
  'text-center text-[10px] font-bold leading-tight border-2 backdrop-blur-md',
  'transition-[box-shadow,transform,opacity,color] duration-300 ease-out',
);

const TAIL_CLASS =
  'pointer-events-none absolute bottom-0 h-2 w-2 rotate-45 border-b border-r transition-colors duration-300 ease-out';

const CURRENT_TURN_RING =
  'ring-2 ring-cyan-200/95 ring-offset-1 ring-offset-[rgba(6,40,28,0.92)] shadow-[0_0_22px_rgba(34,211,238,0.65),0_6px_28px_rgba(0,0,0,0.4)]';

/**
 * Единый «капельный» бейдж над местом (торги, комбо, речь бела): скруглённая таблетка + ромб-хвост.
 *
 * @param {{
 *   bubbleToneClass: string,
 *   tailToneClass: string,
 *   isCurrentTurn?: boolean,
 *   title?: string,
 *   className?: string,
 *   children: React.ReactNode,
 * }} props
 */
export function BelotSeatFloatingBadge({
  bubbleToneClass,
  tailToneClass,
  isCurrentTurn = false,
  title,
  className,
  children,
}) {
  return (
    <div className={cn(OUTER_CLASS, isCurrentTurn && 'z-[20] motion-safe:scale-[1.02]', className)}>
      <span className={cn(PILL_BASE, bubbleToneClass, isCurrentTurn && CURRENT_TURN_RING)} title={title}>
        {children}
      </span>
      <span className={cn(TAIL_CLASS, tailToneClass)} aria-hidden />
    </div>
  );
}
